// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__E3fJF","question":"styles_question__29w9a","description":"styles_description__27XOH"};